import http from '@/utils/http';
import i18n from '@/main';

const baseUrl = '/monitoramento/socioambiental';

export default {
    pesquisar(filtro) {
        return http.get({
            url: baseUrl + `/pesquisa-inteligente?filtro=${filtro}`,
            lockScreen: false
        });
    },

    buscarTotalizadores(body) {
        return http.post({
            url: baseUrl + '/totalizador',
            data: body,
            lockScreen: false
        });
    },

    buscarAreaMonitoradaPorId(id) {
        return http.get({
            url: baseUrl + `/areas-monitoradas/${id}`,
            lockMessage: i18n.t('mensagens.sistema.buscandoDadosDaAreaMonitorada')
        });
    },

    enviarAreasMonitoramento(body) {
        return http.post({
            url: baseUrl + `/salvar/area-monitoramento`,
            data: body,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.enviandoTerritorioParaMonitoramento')
        });
    },

    consultaRelatorio(body, { page, size, sort }) {
        return http.post({
            url:
                baseUrl +
                `/filtrar-relatorio?page=${page - 1}&size=${size}&sort=${sort}`,
            data: body,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoDadosDeMonitoramento')
        });
    },

    buscarRelatorioGrafico(body) {
        return http.post({
            url: baseUrl + `/grafico`,
            data: body,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoDadosDoGrafico')
        });
    },

    exportarRelatorio(body) {
        const fileLink = document.createElement('a');
        try {
            return http
                .post({
                    url: baseUrl + '/requisicao-xlsx',
                    data: body,
                    responseType: 'blob',
                    lockScreen: true,
                    lockMessage: i18n.t('mensagens.sistema.preparandoDadosParaDownload')
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;
                        const filenameRegex =
                            /filename=['"]?([^;\r\n"']*)['"]?;?/;
                        const contentDisposition =
                            response.headers['content-disposition'];

                        fileLink.setAttribute(
                            'download',
                            filenameRegex.exec(contentDisposition)[1]
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    buscarTerritoriosNaoMonitorados(
        filtros,
        { pagina, ordenacao, tamanho = 20 }
    ) {
        return http.post({
            url:
                baseUrl +
                `/nao-monitorados?page=${pagina}&sort=${ordenacao}&size=${tamanho}`,
            data: JSON.parse(JSON.stringify(filtros)),
            lockScreen: false
        });
    },

    consultaDiagnosticoPorIdETerritorioId(
        idDiagnosticoSocioambiental,
        idTerritorio
    ) {
        return http.get({
            url:
                baseUrl +
                `/${idDiagnosticoSocioambiental}/territorio/${idTerritorio}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoDadosDeDiagnosticoSocioambiental')
        });
    },

    buscarSituacaoCamadaCategoria(filtro) {
        return http.post({
            url: baseUrl + `/situacao`,
            data: filtro,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoSituacao')
        });
    },

    buscarSituacaoPorCar(input) {
        return http.post({
            url: baseUrl + `/situacao/car`,
            data: input,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoSituacao')
        });
    },
    buscarAlertasAreasMonitoradasSocioambiental(filtro) {
        const baseUrl_ = '/alertas';

        return http.get({
            url: baseUrl_ + `/areasMonitoradas?filtro=${filtro}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoAlertas')
        });
    },
    buscarCamadasSocioambientais() {
        const baseUrl = '/camadas/buscar/camada-socioambiental';

        return http.get({
            url: baseUrl,
            lockScreen: false
        });
    }
};
